"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React from "react"

// Was MUI Button + styled; now plain Tailwind (renders above the fold on the
// home page, so kept off MUI/Emotion). Dynamic width comes in as a prop.
function SuggestedSearchPill({ text, index, onClick, width }) {
  return (
    <button
      type="button"
      key={`suggested-pill-${index}`}
      onClick={onClick}
      style={{ width }}
      className="mx-1 flex h-[38px] max-w-[125px] cursor-pointer items-center justify-center whitespace-nowrap rounded-[40px] bg-[#F1F1F1] px-[10px] text-center font-roboto text-[16px] font-medium leading-[19px] tracking-[0.03em] text-[#092C3C] transition-colors hover:bg-[#E0E0E0] min-[450px]:px-[19px] min-[900px]:mx-2 min-[900px]:text-[18px]"
    >
      {text}
    </button>
  )
}

export default SuggestedSearchPill
